import addToUnscopables$1 from '../internals/add-to-unscopables.js';

// in popular engines, so it's moved to a separate module

var addToUnscopables = addToUnscopables$1; // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

addToUnscopables('flat');
